import 'babel-polyfill';
import React from 'react';

import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import is, { isMobile } from 'helpers/is';
import App from 'components/App';

import { init } from '@sp/cookie-notice-manager';
import { unregister } from './registerServiceWorker';
import './style/index.scss';
import { COOKIE_ENVIRONMENT } from '@sp/cookie-notice-manager/src/constants';

unregister();

init({
  storageKey: '_sp_',
  active: true,
  environment: COOKIE_ENVIRONMENT.B2B,
  nodeEnv: is().prod ? 'prod' : 'dev',
});

if (navigator.platform.match(/((^Mac)|(^iP)(hone|od|ad))/i)) {
  document.body.classList.add('ios');
}

if (isMobile()) {
  document.documentElement.classList.add('_is-mobile');
}

const { VERSION, TIME, PIPELINE_ID, PROJECT_URL } = process.env;

const pipelineInfo =
  (PROJECT_URL &&
    PIPELINE_ID &&
    `${PIPELINE_ID} (${PROJECT_URL}/pipelines/${PIPELINE_ID})`) ||
  'none';

window.__VERSION__ = () => {
  console.log(`
    Application Version: ${VERSION}
    Deployment Time: ${TIME}
    Pipeline: ${pipelineInfo}
  `);
};

render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
);
